<div
  [hidden]="!active"
  class="rounded-b-30 py-15 pl-20 pr-18 border-2 border-gray-stroke h-197.5"
  [ngClass]="{
    'rounded-tr-30': position === 'first',
    'rounded-tl-30': position === 'last'
  }">
  <ng-content></ng-content>
</div>
